export default function English () {

    return (
        <>
        <section id="english">
            <div className="container-main">
                <div className="pdf-container">
                        <div className="pdf-image">
                        <img src="/img/digital-products.png" alt="autonomo setup kit" className="fluency-pdf" />
                        </div>
                        <div className="pdf-signup">
        <h5><strong>Need help setting up your online teaching business?</strong></h5> 
        <h5><strong>Download my free Autónomo Setup Kit!</strong></h5>
        <p>Includes: Invoice Template, Time & Attendance Tracking, Monthly Budget, and Student Coaching Plan</p>
       {/*  <iframe title="pdf-signup" width="100%" height="505" src="https://0760bbe7.sibforms.com/serve/MUIFAEAGX5GJzBtXKj0i9KpfZTmY1vegkUpizxm-9AYLOrNRGWaCY7tpe4KbVHU8Vj7gBhgIyzFmf-K-2XPuINcRP3SRTI2clk_GVrpAy-77h1Ujmszmovsh23S2ewPqq1hRm-Dm3NTcbKIjXnNkRclOMkaNAVC8IOKRyyBRxKvsktY2szmwRROkeU87Y25iacqXyiVZ_QQ5XRAN"  scrolling="auto" allowFullScreen ></iframe> */}
        <iframe title="autonomo-kit" width="100%" height="505" src="https://0760bbe7.sibforms.com/serve/MUIFAAlEXFjWT9Kkj4kzaL1mS01QTiaCkjEat-MyPL1WILhpMgkl5BoothbZjESjt3YVDRr5MnZWxOe7OU6z4TySEUCT-GDMbgZRgJpT48YTkOV50g3F-dcF_k5tbdru_0lw8FJeMYEzknx0UrtMFA2fw-aGVuz7Z3IaghjDO_q87Egp1Q3z-wQQzuUkT3cRR0eQZAtlrP6hb8_I" frameborder="0" scrolling="auto" allowfullscreen ></iframe>
       
                        </div>
                </div>
        
       
        
        
        </div>
        </section>
        </>
    )
}